import { render, staticRenderFns } from "./TrainerList.vue?vue&type=template&id=6fb27f1b&scoped=true"
import script from "./TrainerList.vue?vue&type=script&lang=js"
export * from "./TrainerList.vue?vue&type=script&lang=js"
import style0 from "./TrainerList.vue?vue&type=style&index=0&id=6fb27f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb27f1b",
  null
  
)

export default component.exports